import React, { useContext } from 'react';
import { Box, Text, HStack, Link, Divider } from '@chakra-ui/react';
import ThemeContext from '../context/ThemeContext';

const Footer = () => {
  const { themeData } = useContext(ThemeContext);

  // Extract theme colors with fallbacks
  const primaryColor = themeData?.colors?.primary || '#2B6CB0';
  //const backgroundColor = themeData?.colors?.background || '#F7FAFC';
  const textColor = themeData?.colors?.text || '#1A202C';

  // Determine if theme is dark (midnight)
  const isDarkTheme = themeData?.id === 'midnight';

  // Footer background - for light themes use white, for dark use secondary color
  const footerBg = isDarkTheme ? themeData?.colors?.secondary || '#2C5282' : 'white';
  
  // Border color should adapt to theme
  const borderColor = isDarkTheme ? primaryColor : 'gray.200';
  
  // Text color with proper contrast
  const footerTextColor = isDarkTheme ? textColor : 'gray.600';

  return (
    <Box 
      bg={footerBg}
      borderTop="1px solid" 
      borderColor={borderColor}
      py={6} 
      mt="auto"
    >
      <Box maxW="container.xl" mx="auto" px={6}>
        <HStack 
          spacing={4} 
          justify="center" 
          align="center" 
          flexWrap="wrap"
        >
          <Text color={footerTextColor} fontSize="sm">
            © 2025 FinanSee. All rights reserved.
          </Text>
          <Divider 
            orientation="vertical" 
            h="16px" 
            borderColor={isDarkTheme ? textColor : 'gray.300'} 
          />
          <Text color={footerTextColor} fontSize="sm">
            Support:{' '}
            <Link 
              href="mailto:info@finansee.eu" 
              color={primaryColor}
              _hover={{ 
                color: isDarkTheme ? themeData?.colors?.accent || '#63B3ED' : 'blue.600', 
                textDecoration: 'underline' 
              }}
            >
              info@finansee.eu
            </Link>
          </Text>
        </HStack>
      </Box>
    </Box>
  );
};

export default Footer;